import React, { Component, createRef } from "react";
import "component/menu/Dropdown/styles.scss";
import { ReactComponent as DropdownUpArrow } from 'assets/icons/arrow_drop_up.svg';
import { ReactComponent as DropdownDownArrow } from 'assets/icons/arrow_drop_down.svg';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.dropdownRef = createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  selectOption = (option) => {
    this.setState({ selectedOption: option, isOpen: false });
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  }

  render() {
    const { isOpen } = this.state;

    return (
      <div className="dropdown-container" ref={this.dropdownRef}>
        <div
        className={
            `dropdown ${this.props.availableMonths.size >= 1 ? '' : 'disabled'}`}
          onClick={this.toggleDropdown}
        >
          <span>{ this.props.selectedMonth }</span>
          <span>{ isOpen ? <DropdownUpArrow /> : <DropdownDownArrow /> }</span>
        </div>
        {isOpen && (
          <ul
            className="dropdown-select"
          >
            {this.props.availableMonths && this.props.availableMonths.map((month, index) => (

                <li
                className={this.props.selectedMonth === month.get('name') ? "selected" : ''}
                key={index}
                onClick={() => {
                    this.props.handleChange(month.get('id'), month.get('name'), index);
                    this.setState({ isOpen: false });
                }}
                >
                    {month.get('name')}
                </li>
            ))}

          </ul>
        )}
      </div>
    );
  }
}

export default Dropdown;
